import { Field } from 'ngx-angular-query-builder'
import { ArrayToFilterListItemBuilder } from '@common/filter/services/array-to-filter-list-item-builder';
import { CashBalancesModel } from '../models/cash-balances.model';
import {
  FieldMetadataCollectionBuilder,
  FilterOperators,
  FieldMetadata,
  FieldMetadataCollection,
  FilterFieldProvider,
  FilterListItem,
  FilterAvailabilityCallbacks
} from '@common/filter/filtering';
import { DashboardIdentifiers } from '@dashboards/dashboard-identifiers';

export class CashBalancesFilterFieldProvider implements FilterFieldProvider {

  private readonly fieldMetaDataCollection = new FieldMetadataCollection();
  private readonly fieldPredicates: FilterAvailabilityCallbacks;

  constructor(
    private readonly cashbalances: Array<CashBalancesModel>,
    effectiveProduct: string,
    currentDashboard: string) {
    this.initialiseFields();
    this.fieldPredicates = new FilterAvailabilityCallbacks(currentDashboard, effectiveProduct);
  }

  private initialiseFields() {

    const fieldMetaDataBuilder = new FieldMetadataCollectionBuilder(this.fieldMetaDataCollection);
    const optionBuilder = new ArrayToFilterListItemBuilder(this.cashbalances);

    optionBuilder.forProperty('ClientParent', 'ClientParentRef', (x: CashBalancesModel) => x.ClientParentRef);
    optionBuilder.forProperty('Client', 'ClientRef', (x: CashBalancesModel) => x.ClientRef);
    optionBuilder.forProperty('Property', 'PropertyRef', (x: CashBalancesModel) => `${x.PropertyRef} - ${x.PropertyName}`);
    optionBuilder.forProperty('SubLedger', 'SubLedger', (x: CashBalancesModel) => `${x.SubLedgerCode} - ${x.SubLedger}`);
    optionBuilder.forProperty('Type', 'Type', (x: CashBalancesModel) => x.Type);

    const options = optionBuilder.build();
    const mojoHomeDashboardOnly = () => this.fieldPredicates.includedOnDashboardsForMojoDashboardProduct([DashboardIdentifiers.HomeDashboard]);

    fieldMetaDataBuilder.add('Client Parent', 'ClientParentRef', 'number', FilterOperators.Scalar, options.get('ClientParent'), mojoHomeDashboardOnly);
    fieldMetaDataBuilder.add('Client', 'ClientRef', 'number', FilterOperators.Scalar, options.get('Client'), mojoHomeDashboardOnly);
    fieldMetaDataBuilder.add('Property', 'PropertyRef', 'number', FilterOperators.Scalar, options.get('Property'));
    fieldMetaDataBuilder.add('Sub Ledger', 'SubLedger', 'category', FilterOperators.CategoryDefaults, options.get('SubLedger'));
    fieldMetaDataBuilder.add('Type', 'Type', 'category', FilterOperators.CategoryDefaults, options.get('Type'));

  }

  getFilterFields(): Array<Field> {
    return this.fieldMetaDataCollection.getFilterFields();
  }


  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

}
